import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

export interface TradableModel {
	amount: number | string;
	id: string;
	addName: boolean;
	hasDescription: boolean;
	description: string;
}

@Component({
	selector: "order-tradable",
	templateUrl: "./order-tradable.component.html",
	styleUrls: ["./order-tradable.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class OrderTradableComponent {
	@Input() public tradableModel: TradableModel;
	@Input() public resetPriceStyle = false;
	@Input() public buySellModal = false;
}
